import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-11_01",
  version: "2026.06.11",
  date: "11 Jun 2026",
  sinceCommit: "d75b94f",
  gameplay: [
    {
      text: "The spell system has been fully reworked; Now grouped by school (Fire, Frost, Self AoE, Bolts, Mobility, and so on). Buying a spell fills your next free keybind slot in order **1 → 2 → 3 → 4 → Q → W → E → R** — you are no longer locked to one spell list per column.",
    },
    {
      text: "Everyone starts with **Fireball** and **Scourge**; the lobby starter picker is gone.",
    },
    {
      text: "**Spacebar** is now a skill slot — a wide key on the action bar below **Q W E R**, with the spell icon centered in the bar. You still equip **8** spells per match; shop and draft fill **1 → R** only — use Space by dragging a skill onto it.",
    },
    {
      text: "Rearrange your hotbar: hold **Shift**, drag a skill out of its slot, and drop it on another key to **swap** two spells or **move** onto an empty slot. Your layout sticks for the rest of the match (not available in All Random).",
    },
    {
      text: "All skill passives and synergies cost **1 point** each.",
    },
    {
      text: "In team modes (2v2 and up), round wins and match standings track **team** wins — all teammates share the same round-win count, and the match-over screen lists teams instead of duplicating per player.",
    },
    {
      text: "Sandbox mode starts with **99 SP**, **99 PP**, and **99 Sy** for kit testing (was **24** / **12** / **4**).",
    },
    {
      text: "**PvE mode** (lobby host): co-op gauntlet vs huge bosses on a slower-shrinking arena. **300g** prep budget, then **Skill Draft** between encounters to build your kit (same point budgets as normal matches).",
    },
    {
      text: "First PvE boss **Inferna** (fire): **Ember Lance**, **Pyre Well**, and **Scorch Burst**; **weak to Frost**. At **50% HP** she channels **Inferno Nova** — a lethal shockwave after **3s**; hide behind stone. **Cinder** wraiths join at **40% HP** and hurl ember bolts.",
    },
    {
      text: "Inferna fights use **three rings of stone pillars** (**42** radius, up from **34**); each arena shrink **explodes the outermost ring**, so cover moves inward with the void.",
    },
    {
      text: "Below **15% HP**, your wizard pulses red on the health bar and robe tint so low-health knockback risk is easier to read.",
    },
    {
      text: "Sandbox **dumb enemies** take knockback like real targets and **respawn on death**.",
    },
    {
      text: "Sandbox **no longer ends** when you kill all spawned enemies.",
    },
    {
      text: "Sandbox **platform size** steps shrink and expand over **3 seconds**, matching ranked arena timing; pillars still crumble as the edge passes them.",
    },
    {
      text: "Sandbox **Respawn rocks** — scatter a fresh set of pillars without resetting positions or spells.",
    },
    {
      text: "The training dummy is now a **scarecrow target** with archery rings on the chest.",
    },
    {
      text: "Hold **left click** to keep updating click-to-move toward the cursor.",
    },
    {
      text: "Sandbox: press **S** (or **Skill draft**) to run a spell-draft pick in the arena — the match pauses like the spellbook while you choose.",
    },
    {
      text: "Bot skill tier shown in-match now matches the tier set in the lobby roster.",
    },
  ],
  skills: [
    {
      spellId: "illusionist",
      changes: [
        {
          text: "Multishot volleys on every partner projectile (Fireball, Freeze, Ice Lance, Drain, Disable, Hook, Link, Splitter, Bouncer, Homing, Boomerang, Swap) now correctly tally side-bolt damage — **75%** per side bolt, **25%** if all three land on one target; only one bolt knocks back per enemy.",
        },
      ],
    },
    {
      spellId: "timeshift",
      changes: [
        {
          text: "During the **2s** rewind, a semi-transparent ghost stays at your cast position so opponents can read where you snap back.",
        },
      ],
    },
    {
      spellId: "homing",
      changes: [
        {
          text: "While in flight, retargets to the **nearest enemy within 150** units of the bolt.\nTurn rate **8 → 5** rad/s.",
        },
      ],
    },
    {
      spellId: "hook",
      changes: [
        {
          text: "New control skill (**95g**, **15s** CD, **50** damage): throw a hook on a chain. Direct hit or running into the hook **reels the target all the way to you** — no bleed, unlike Link.",
        },
        {
          text: "Hook and Link tethers render as a **linked chain** in flight and while reeling.",
        },
      ],
    },
    {
      spellId: "thrust",
      changes: [
        {
          text: "Dash slam knockback **1× → 2×** HP damage (damage unchanged).",
        },
      ],
    },
  ],
};
